export default {
  feedsList: [],
  feedDetail: {},
  dashboardFeed: {},
};
